import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { BaseQueryAccessor } from "./BaseQueryAccessor";
import { MultiMatchQuery, BoolShould, SimpleQueryString } from "../query";

var assign = require("lodash/assign");

export var QueryAccessor =
/*#__PURE__*/
function (_BaseQueryAccessor) {
  _inherits(QueryAccessor, _BaseQueryAccessor);

  function QueryAccessor(key) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, QueryAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(QueryAccessor).call(this, key));
    _this.options = options;
    _this.options.queryFields = _this.options.queryFields || ["_all"];
    return _this;
  }

  _createClass(QueryAccessor, [{
    key: "fromQueryObject",
    value: function fromQueryObject(ob) {
      _get(_getPrototypeOf(QueryAccessor.prototype), "fromQueryObject", this).call(this, ob);

      if (this.options.onQueryStateChange) {
        this.options.onQueryStateChange();
      }
    }
  }, {
    key: "buildSharedQuery",
    value: function buildSharedQuery(query) {
      var _this2 = this;

      var queryStr = this.state.getValue();

      if (queryStr) {
        var queryBuilder = this.options.queryBuilder || SimpleQueryString;
        var simpleQuery = queryBuilder(queryStr, assign({
          fields: this.options.queryFields
        }, this.options.queryOptions));
        var queries = [simpleQuery];

        if (this.options.prefixQueryFields) {
          queries.push(MultiMatchQuery(queryStr, assign(this.options.prefixQueryOptions, {
            type: "phrase_prefix",
            fields: this.options.prefixQueryFields
          })));
        }

        query = query.addQuery(BoolShould(queries));

        if (this.options.addToFilters) {
          query = query.addSelectedFilter({
            name: this.options.title,
            value: queryStr,
            id: this.key,
            remove: function remove() {
              return _this2.state = _this2.state.clear();
            }
          });
        } else {
          query = query.setQueryString(queryStr);
        }

        return query;
      }

      return query;
    }
  }]);

  return QueryAccessor;
}(BaseQueryAccessor);